import Templates from "../../templates";
import { ConnectWithUsPage } from "../../organisms";
const ConnectWithUs = () => {

  return(
    <Templates loading={false}>
      <ConnectWithUsPage/>
    </Templates>
  )
}

export default ConnectWithUs;